export default [

    {
        //创建订单
        path: '/dingd/createNewOrder',
        component: () => import( '@/views/dingd/createNewOrder.vue'),
    },
    {
        //创建订单
        path: '/dingd/createShouhouOrder',
        component: () => import( '@/views/dingd/createShouhouOrder.vue'),
    },{
        //创建外销订单
        path: '/dingd/waixiao',
        component: () => import( '@/views/dingd/waixiao.vue'),
    },{
    //订单列表
        path: '/dingd/myOrderList',
        component: () => import( '@/views/dingd/myOrderList.vue'),
    },{
    //订单详情
        path: '/dingd/myOrderDetails',
        component: () => import( '@/views/dingd/myOrderDetails.vue'),
    },{
    //订单审批
        path: '/dingd/orderApproval',
        component: () => import( '@/views/dingd/orderApproval.vue'),
    },
    {
    //发货计划
        path: '/dingd/orderSend',
        component: () => import( '@/views/dingd/orderSend.vue'),
    },
	{
	//订单创建
	    path: '/dingd/orderCreate',
	    component: () => import( '@/views/dingd/orderCreate.vue'),
	},
	//采购订单列表
	{
		path: '/dingd/purchaselist',
	    component: () => import( '@/views/dingd/purchaselist.vue'),
        meta:{nwxflag:'all',keepAlive:true, title: '采购订单列表',
            isTabsPage: true}
	},
	// 发票信息维护
	// {
	// 	path: '/dingd/invoicemaintenance',
	// 	name: '/dingd/invoicemaintenance',
	// 	component: () => import( '@/views/dingd/invoicemaintenance.vue'),
	// },
    //采购订单内销列表
    {
        path: '/dingd/purchaselistNx',
        component: () => import( '@/views/dingd/purchaselist.vue'),
        meta:{nwxflag:'nx',keepAlive:true,title: '采购订单列表(内销)',
            isTabsPage: true}
    },
    //采购订单外销列表
    {
        path: '/dingd/purchaselistWx',
        component: () => import( '@/views/dingd/purchaselist.vue'),
        meta:{nwxflag:'wx',keepAlive:true,title: '采购订单列表(外销)',
            isTabsPage: true}
    },
	//订单查看
	{
		path: '/dingd/orderThrough',
	    component: () => import( '@/views/dingd/orderThrough.vue'),
	},
    //上海销售订单查看
	{
		path: '/dingd/orderThroughSh',
	    component: () => import( '@/views/dingd/orderThroughSh.vue'),
	},
    //9390卖6200的采购订单
	{
		path: '/dingd/orderThroughHk',
	    component: () => import( '@/views/dingd/orderThroughHk.vue'),
	},
	//订单查看-采购经理可编辑
	{
		path: '/dingd/orderThrough-edit',
	    component: () => import( '@/views/dingd/orderThrough-edit.vue'),
	},
    //订单审核页
    {
        path: '/dingd/orderCgApprove',
        component: () => import( '@/views/dingd/orderCgApprove.vue'),
    },
    //外销订单，采购审核页
    {
        path: '/dingd/orderCgWxddApprove',
        component: () => import( '@/views/dingd/orderCgWxddApprove.vue'),
    },
    //上海订单，采购审核页
    {
        path: '/dingd/orderCgShddApprove',
        component: () => import( '@/views/dingd/orderCgShddApprove.vue'),
    },

    // OEM订单审核页
    {
        path: '/dingd/orderCgLdApprove',
        component: () => import( '@/views/dingd/orderCgLdApprove.vue'),
    },
    //采购订单付款
    {
        path:"/dingd/orderCgPayment",
        component: () => import( '@/views/dingd/orderCgPayment.vue'),
    },

    //订单下拉权限
    {
        path:"/xiaoshouQuyuGuanxikongzhi",
        component: () => import( '@/views/basic/xiaoshouQuyuGuanxikongzhi.vue'),
        meta: {
            title: '订单下拉权限',
            isTabsPage: true,
            keepAlive: true
        }
    },
   // 财务报表
    {
        path:'/dingd/finance',
        component: () => import( '@/views/dingd/finance.vue'),
        meta: {
            title: '财务报表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    //随货单
    {
        path:'/dingd/goodsList',
        component: () => import( '@/views/dingd/goodsList.vue'),
        meta: {
            title: '随货单',
            isTabsPage: true,
            keepAlive: true
        }
    },



    // 发票信息维护
    {
        path: '/dingd/invoicemaintenance',
        name: '/dingd/invoicemaintenance',
        component: () => import( '@/views/dingd/invoicemaintenance.vue'),
    },











    {
        path: '/dingd/material',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/dingd/material/material.vue'),
        meta: {
            title: '国外订单',
            requireAuth: true
        }
    },
    {
        path: '/dingd/material/orderDetail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/dingd/material/order_detail.vue'),
        meta: {
            title: '订单详情',
            requireAuth: true
        }
    },
    {
        // 国外订单
        path: '/dingd/material/bsc',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/dingd/material/bsc.vue'),
    },
    {
        // 内销标准订单
        path: '/dingd/material/inland',
        component: () => import( '@/views/dingd/material/inland.vue'),
    },
    {
        // 内销订单
        path: '/dingd/material/neixiao',
        component: () => import( '@/views/dingd/material/neixiao.vue')
    },
	{
	    // 外销订单
	    path: '/dingd/material/waixiao',
	    component: () => import( '@/views/dingd/material/waixiao.vue')
	},

    {
        path: '/dingd/material/assess',
        component: () => import('@/views/dingd/material/assess.vue')
    },
    {
        //订单详情-审批页面
        path: '/dingd/material/particulars',
        component: () => import('@/views/dingd/material/particulars.vue')
    },
    {
        //订单详情-个人页面
        path: '/dingd/material/ownDetails',
        component: () => import('@/views/dingd/material/ownDetails.vue')
    },
	{
	    //服务类订单创建
	    path: '/dingd/material/fuwu',
	    component: () => import( '@/views/dingd/material/fuwu.vue')
	},
    {
        //背靠背付款情况报表
        path: '/dingd/backMoneyList',
        component: () => import( '@/views/dingd/backMoneyList.vue'),
        meta: {
            title: 'OEM付款报表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //订单创建
        path: '/dingd/orderCreateYC',
        name: '/dingd/orderCreateYC',
        component: () => import( '@/views/dingd/orderCreateYC.vue'),
    },
    {
        //销售订单审批后单独审批采购订单
        path: '/dingd/orderCreateApprove',
        name: '/dingd/orderCreateApprove',
        component: () => import( '@/views/dingd/orderCreateApprove.vue'),
    },
    //内销套餐订单，采购审核页
    {
        path: '/dingd/orderTcCgApprove',
        component: () => import( '@/views/dingd/orderTcCgApprove.vue'),
    },
    //订单生成PR
    {
        path: '/dingd/orderCreatePR',
        component: () => import( '@/views/dingd/orderCreatePR.vue'),
    },
    //采购订单PR
    {
        path: '/dingd/purchaselistPR',
        component: () => import( '@/views/dingd/purchaselistPR.vue'),
        meta:{nwxflag:'wx',keepAlive:true,title: 'PR采购单列表',
            isTabsPage: true
        }
    },


    /**
     * 供应商区域关系对照
     */
    //供应商区域关系对照
    {
        path: '/supplierarea/supplierAreaCompare',
        component: () => import( '@/views/dingd/supplierarea/supplierAreaCompare.vue'),
        meta:{keepAlive:true,title: '供应商区域关系对照',
            isTabsPage: true
        }
    },

    //供应商产品关系对照
    {
        path: '/supplierarea/supplierProductCompare',
        component: () => import( '@/views/dingd/supplierarea/supplierProductCompare.vue'),
        meta:{keepAlive:true,title: '供应商产品关系对照',
            isTabsPage: true
        }
    },

    //售后服务订单采购单审核页
    {
        path: '/dingd/orderCgApproveSh',
        component: () => import( '@/views/dingd/orderCgApproveSh.vue'),
    },

]
